
import React from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
// // import 'react-pivottable/pivottable.css';
 import 'src/assets/css/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import { aggregators } from 'react-pivottable/Utilities';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import Service from "src/api/Service";
import colorPalette from "src/assets/js/colorPalette";
const PlotlyRenderers = createPlotlyRenderers(Plot);

class PivotTable extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            tableData:[],
            defaultRows : [],
            defaultCols : [],
            isFetching:true,
            fieldsToShow:[],
            vals:[],
            hiddenFromAggregators:['KPI','Period','Channel','Products','Timeseries'],
            aggregatorName:'',
            rendererName:'',
            heightinPx :null,
            widthinPx :null,
            countFilter:false,
            CombinedRenderers : {},
            Aggregators : {},
            hiddenFromDragDrop : [],
            Message : "No Data Available"
        };

        this.plotlyOptions = {
          width : this.state.widthinPx ,
          height: this.state.heightinPx ,
          showlegend: false,
          barmode: 'group',
          width: 1100,
          colorway:colorPalette[0]['KPIDashboard'][this.props.palette],
  
        };
    
    }

   async fetchData(){
    var obj ={};
    const defaultfilterData = JSON.parse(localStorage.getItem("defaultfilterData"));
    obj['data']=defaultfilterData;
    obj['keyname']=this.props.prams.keyname;
    console.log(obj)
    Service.post("dashboard/kpis",obj,(status,data)=>{           
            if(status==200){       
              console.log(data);
  
                var field= data['fieldsToShow'];
                var dataset= data['data'];
                console.log(data);
                console.log(data['Vals']);
                 var finalSet=[];
                dataset.map(item=>{
                   var record={};
                   for (var key in field) {
                       var value = field[key];
                       record[value['sTitle']]= item[key]
                    };
                    finalSet.push(record);
                });

                let combinedRenderers = {}
                Object.entries(PlotlyRenderers).filter(([key,value])=>{
                  if(key === data['rendererName']){
                    combinedRenderers[data['rendererName']] = value
                  }
                })

                Object.entries(TableRenderers).filter(([key,value])=>{
                  if(key === data['rendererName']){
                    combinedRenderers[data['rendererName']] = value
                  }
                })

                let Aggregator ={}

                Object.entries(aggregators).filter(([key,value])=>{
                  if(key === data['aggregatorName']){
                    Aggregator[data['aggregatorName']] = value
                  }
                })

                this.setState({   
                    tableData: finalSet,       
                    fieldsToShow: field,    
                    defaultRows:data['defaultRows'], 
                    defaultCols:data['defaultCols'], 
                    vals:data['Vals'], 
                    aggregatorName:data['aggregatorName'], 
                    rendererName:data['rendererName'], 
                    hiddenFromAggregators:data['hiddenFromAggregators'], 
                    hiddenFromDragDrop : data['hiddenFromDragDrop'],
                    CombinedRenderers : combinedRenderers ,
                    Aggregators : Aggregator ,
                    Message : data['message'],
                  isFetching: false,         
                });
            }
        })
    }


    async filterSummary(filterData){
      var url = "dashboard/kpis";
      var obj ={};
      obj['data']=filterData;
      obj['keyname']=this.props.prams.keyname;
        await Service.post(url,obj,(status,data)=>{
          console.log(data)
          if(status==200){       

              var field= this.state.fieldsToShow;
              var dataset= data['data'];
               var finalSet=[];
              dataset.map(item=>{
                 var record={};
                 for (var key in field) {
                  var value = field[key];
                      record[value['sTitle']]= item[key]
                  };
                  finalSet.push(record);
              });

              let combinedRenderers = {}
                Object.entries(PlotlyRenderers).filter(([key,value])=>{
                  if(key === data['rendererName']){
                    combinedRenderers[data['rendererName']] = value
                  }
                })

                Object.entries(TableRenderers).filter(([key,value])=>{
                  if(key === data['rendererName']){
                    combinedRenderers[data['rendererName']] = value
                  }
                })
       
                let Aggregator ={}

                Object.entries(aggregators).filter(([key,value])=>{
                  if(key === data['aggregatorName']){
                    Aggregator[data['aggregatorName']] = value
                  }
                })
                
              this.setState({   
                tableData: finalSet,                 
                isFetching: false,   
                CombinedRenderers : combinedRenderers ,  
                Message : data['message'],
                Aggregators : Aggregator 
              });
          }
      })
  }

    chageFn(e){
        
        this.setState(e);
       
    }

    setPixelDimensions() {
      const container = document.getElementById('PivotTable1');
      console.log(container)
      if (container) {
        const parentWidth = container.parentElement.clientWidth;
        const parentHeight = container.parentElement.clientHeight;
  
        const widthInPixels = (parentWidth * this.props.prams.width) / 150;
        const heightInPixels = (parentHeight * this.props.prams.height) / 130;
       
        console.log("--------width",parentWidth,parentHeight,widthInPixels,heightInPixels)
        this.setState({
          widthinPx : widthInPixels,
          heightinPx:heightInPixels
        })
  
        this.plotlyOptions = {
            ...this.plotlyOptions,
            width : widthInPixels,
            height : heightInPixels 
          }
      }
    }

  componentDidMount(){
    this.fetchData();
    document.addEventListener('DOMContentLoaded', () => {
      const element = document.querySelector('.g-ytitle');
      console.log(element);
    });
    this.setPixelDimensions() ;
  }

  componentDidUpdate(){
    if(this.props.filterData.length == undefined  && this.state.countFilter != this.props.countFilter){
      this.setState({
        countFilter:this.props.countFilter
      })
      this.filterSummary(this.props.filterData);
    }
    if(this.state.widthinPx == null && this.state.heightinPx == null){
      this.setPixelDimensions() ;
    }
  }

    render() {
      const plotlyOptions = {
        showlegend: false,
        barmode: 'group',
   
        colorway:colorPalette[0]['KPIDashboard'][this.props.palette],

      };

        if(this.state.isFetching){
            return(<>
                     <p>Please wait...</p>
                </>
            );
        }

        if(this.state.tableData.length==0){
          return ( <>
            <div className='row'>
                        <div className='col-lg-5'>
                          <div className='componentNameC'>{this.props.prams.component}</div>
                        </div>
          
                        <div className='col-lg-5'>
                        </div>  
          
                        <div className='col-lg-2'>
        
                    </div>
            </div>
          
            <div className="p-2">
          
              <div className="row">
          
          
              <div className='col-lg-12'  style={{height: '328px',display: 'grid',placeItems:'center'}}>          
                <center style={{color:'#566573', fontWeight:'500'}}> {this.state.Message}</center>
              </div>
          
          </div>
          </div>
          
          </>);
        }

        return (
            <>
            <div className='row'>
                        <div className='col-lg-5'>
                          <div className='componentNameC'>{this.props.prams.component}</div>
                        </div>   


            </div>
    
            <div className="p-2 PivotTable1" id='PivotTable1'>
    
              <div className="row PivotTable2">   
    
              <div className='col-lg-12 PivotTable3'>
              <PivotTableUI
                ref={this.myRef}
                rows={this.state.defaultRows} 
                cols={this.state.defaultCols}
                data={this.state.tableData}
                rendererName={this.state.rendererName}
                // renderers={customRenderers}
                aggregatorName={this.state.aggregatorName}
                vals={this.state.vals}
                hiddenFromAggregators={this.state.hiddenFromAggregators}
                hiddenFromDragDrop={this.state.hiddenFromDragDrop}
                aggregators={this.state.Aggregators}
                onChange={s => this.chageFn(s)}
                renderers={this.state.CombinedRenderers}
                plotlyOptions={this.plotlyOptions}
                {...this.state}
            />
    
              </div>
    
    </div>
    </div>
        
        </>

            
        );
    }
}

export default PivotTable